const styles = {
	"article-tag": {
		color: "#00b7bd",
		fontSize: 12,
		font: "AvenirNext",
	},
	h1: {
		characterSpacing: 0.28,
		fontSize: 20,
		color: "#6e787f",
	},
	meta: {
		fontSize: 8,
		lineHeight: 1.18,
		characterSpacing: 0.1,
		color: "#6e787f",
		bold: true,
	},
	byline: {
		fontSize: 10,
		lineHeight: 1.18,
		characterSpacing: 0.1,
		color: "#6e787f",
		font: "AvenirNext",
	},
	"meta-subheader": {
		bold: false,
	},
	firstLine: {
		font: "Sentinel",
		color: "#007e87",
		bold: true,
		fontSize: 8,
	},
	body: {
		margin: [0, 25, 25, 0],
		fontSize: 8,
		color: "#2b3136",
		lineHeight: 1.18,
		characterSpacing: 0.1,
	},
	"subhead-1": {
		fontSize: 10,
		characterSpacing: 0.75,
		lineHeight: 1,
		color: "#00b7bd",
		bold: true,
	},
	"home-url": {
		bold: true,
		fontSize: 8,
		color: "#000",
	},
	"page-url": {
		color: "#007e87",
		bold: true,
		fontSize: 8,
		italics: true,
	},
	"exhibit-label": {
		color: "#6e787f",
		bold: true,
		fontSize: 10,
		lineHeight: 1,
	},
	"exhibit-subtitle-override": {
		italics: true,
		fontSize: 10,
	},
	"exhibit-title": {
		color: "#00b7bd",
		fontSize: 8,
		lineHeight: 1,
		bold: true,
	},
	"exhibit-subtitle": {
		color: "#6e787f",
		fontSize: 7,
		lineHeight: 1,
		italics: true,
	},
	"exhibit-desc": {
		color: "#6e787f",
		fontSize: 8,
		lineHeight: 1,
	},
	"exhibit-disclosure": {
		font: "Sentinel",
		italics: true,
		fontSize: 8,
		color: "#333f48",
		lineHeight: 1,
	},
	"exhibit-disclosure-link": {
		font: "Sentinel",
		italics: true,
		bold: true,
		fontSize: 8,
		color: "#007e87",
	},
	footer: {
		fontSize: 8,
		italics: true,
		color: "#6e787f",
		bold: false,
		font: "Sentinel",
	},
	default: {
		fontSize: 10,
		font: "Avenir",
		color: "#333f48",
		lineHeight: 1.3,
		characterSpacing: 0.1,
	},
	footNote: {
		margin: [0, 0, 0, 0],
		fontSize: 8,
		font: "Avenir",
		color: "#333f48",
		lineHeight: 1.18,
		characterSpacing: 0.1,
	},
	disclosures: {
		margin: [0, 4, 0, 0],
		fontSize: 10,
		font: "AvenirNext",
		color: "#333f48",
		lineHeight: 1.18,
		characterSpacing: 0.1,
	},
	disclosure: {
		fontSize: 10,
		font: "AvenirNext",
		color: "#333f48",
		lineHeight: 1.18,
		characterSpacing: 0.1,
	},
	disclosureLink: {
		fontSize: 10,
		font: "AvenirNext",
		color: "#007e87",
		lineHeight: 1.18,
		characterSpacing: 0.1,
	},
	"disclosure-bold-black": {
		bold: true,
		fontSize: 8,
		italics: true,
		color: "#6e787f",
		font: "Sentinel",
	},
	"disclosure-footer-risk": {
		fontSize: 12,
		font: "Avenir",
		color: "#000000",
		lineHeight: 1.18,
		characterSpacing: 0.1,
		bold: true,
	},
	"disclosure-esma": {
		fontSize: 12,
		font: "Avenir",
		color: "#000000",
		lineHeight: 1.18,
		characterSpacing: 0.1,
		bold: false,
	},
	"disclosure-image-risk": {
		fontSize: 12,
		font: "AvenirNext",
		color: "#000000",
		lineHeight: 1.18,
		characterSpacing: 0.1,
		bold: true,
	},
	"disclosure-risk-link": {
		fontSize: 12,
		font: "Avenir",
		color: "#007e87",
		lineHeight: 1.18,
		characterSpacing: 0.1,
		bold: true,
	},
	appendix: {
		fontSize: 8,
		font: "Avenir",
		color: "#333f48",
		lineHeight: 1.18,
		characterSpacing: 0.1,
	},
	appendixLink: {
		fontSize: 8,
		font: "Avenir",
		color: "#007e87",
		lineHeight: 1.18,
		characterSpacing: 0.1,
	},
	appendixTitle: {
		margin: [0, 20, 0, 2],
		fontSize: 9,
		font: "Avenir",
		color: "#6e787f",
		lineHeight: 1.18,
		characterSpacing: 0.1,
		bold: true,
	},
	usage: {
		fontSize: 9,
		font: "Avenir",
		color: "#ab2328",
		bold: true,
	},
	"usage-header-not-bold": {
		fontSize: 9,
		font: "Avenir",
		color: "#ab2328",
		bold: false,
	},
	cmax: {
		fontSize: 8,
		lineHeight: 1.18,
		characterSpacing: 0.1,
		font: "Avenir",
		color: "#333f48",
	},
	link: {
		color: "#007e87",
		font: "Avenir",
	},
	footnoteLink: {
		color: "#007e87",
		margin: [0, 0, 0, 0],
		fontSize: 8,
		font: "Avenir",
		lineHeight: 1.18,
		characterSpacing: 0.1,
	},
	br: {
		margin: [0, 0, 0, 10],
	},
	blackBold: {
		color: "#000000",
		font: "AvenirNext",
	},
	externalLink: {
		color: "#00b7bd",
		fontSize: 8,
		lineHeight: 1,
		bold: true,
	},
	keyTakeaway: {
		color: "#00666e",
		bold: true,
	},
	shareableQuote: {
		font: "Sentinel",
		color: "#00666e",
		fontSize: 16,
		italics: true,
		lineHeight: 1.12,
	},
	sup: {
		sup: true,
	},
	sub: {
		sub: true,
	},
};

export default styles;
